var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sampleobject.isLabSuppliedFrame)?_c('lab-supply-frame-info-review',{attrs:{"frame":_vm.sampleobject.labSuppliedFrame,"sampleobject":_vm.sampleobject}}):_c('frame-to-come-info-review',{attrs:{"sampleobject":_vm.sampleobject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }